import * as React from "react";

import "./approve-confirm-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {UseState}       from "@Common/react/use-state";
import {consumeContext} from "@Common/react/context";
import {DeprecatedModalService2}   from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const ApproveConfirmModal = ({next: rootNext}) => cs(
    consumeContext("userLevels"),
    ["confirmError", (_, next) => UseState({next})],
    ["confirming", (_, next) => UseState({next})],
    ["modal", ({confirming}, next) => <DeprecatedModalService2 {...{
        render: ({id, confirm, finalApprovalLevel}, rm) => ({
            size: "small",
            content: next({
                close: () => rm(),
                confirm,
                id,
                finalApprovalLevel,
            }),
            onPassiveClose: () => !confirming.value,
        }),
        hideCloseButton: !!confirming.value,
        next: rootNext,
    }}/>],
    ({modal, userLevels, confirming, confirmError}) => (
        <div className="approve-confirm-modal-909" xd-qa-type="modal" xd-qa-name="Approve Modal">
            <div className="content"> 
                {!confirmError.value && (confirming.value ? (
                    <div className="message" xd-qa-type="label" xd-qa-name="Confirm Message">
                        Processing request, please wait...
                    </div>
                 ) : (
                    <>
                        <div className="message" xd-qa-type="label" xd-qa-name="Confirm Message">
                            This will immediately send {modal.id} to {
                                (modal.finalApprovalLevel && modal.finalApprovalLevel != userLevels.userLevel) ? 'the next approver level' : 'production' 
                            }.
                        </div>
                        <div className="sub-text" xd-qa-type="label" xd-qa-name="Confirm Question">
                            Are you sure you want to approve?
                        </div>
                    </>
                 ))}

                {confirmError.value && <>
                    <div className="message" xd-qa-type="label" xd-qa-name="Confirm Message">
                        Request failed to process:
                    </div>
                    <div className="sub-text error" xd-qa-type="label" xd-qa-name="Error Message">
                        {confirmError.value}
                    </div>
                </>}
            </div>

            <div className="footer">
                {!confirmError.value ? <>
                    {!confirming.value && (
                        <button {...{
                            className: "cancel",
                            onClick: () => modal.close(),
                            "xd-qa-type": "button",
                            "xd-qa-name": "Cancel",
                        }}>
                            Cancel
                        </button>
                    )}

                    <button {...{
                        className: "proceed",
                        disabled: confirming.value,
                        onClick: async () => {
                            confirming.onChange(true);
                            confirmError.onChange(null);

                            const {success, error} = await modal.confirm();
                            if (success) {
                                modal.close();
                            } else {
                                confirmError.onChange(error);
                                confirming.onChange(false);
                            }
                        },
                        "xd-qa-type": "button",
                        "xd-qa-name": "ok",
                    }}>
                        OK
                    </button>
                </> : <>
                    <button {...{
                        className: "proceed",
                        onClick: () => modal.close(),
                        "xd-qa-type": "button",
                        "xd-qa-name": "Close",
                    }}>
                        Close
                    </button>
                </>}
            </div>
        </div>
    )
);